import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { useEffect, useState } from "react"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

// Detects the visitor's OS on the client so the UI can show the right
// keyboard shortcut (⌘K on macOS, Ctrl K elsewhere). Returns null during SSR
// and the first render to avoid a hydration mismatch; it flips to the real
// value right after mount.
export function useIsMac(): boolean | null {
    const [isMac, setIsMac] = useState<boolean | null>(null)
    useEffect(() => {
        const platform = (navigator as any).userAgentData?.platform || navigator.platform || navigator.userAgent
        setIsMac(/mac/i.test(platform))
    }, [])
    return isMac
}

// The internal (auth-gated) area has its own search index, served under
// /internal/ so Cloudflare Access protects it. Public pages use the public
// index. Call only on the client (reads window.location).
export function searchIndexUrl(): string {
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/internal/")) {
        return "/internal/search-index.json"
    }
    return "/search-index.json"
}
